import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-navigation-sign-out-icon',
  templateUrl: './navigation-sign-out.component.html'
})
export class NavigationSignOutComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
